import React from "react";
import { RiskStatusIcon } from "@sscs/ui";
import { ALL_RISKS_PASSED_LABEL, ASSESSMENT_TYPE_TO_TITLE, } from "../../../../constants";
import { getFinalRisk } from "../../../../utils/risk";
import RenderChildrenWrapper from "../../../common/RenderChildrenWrapper";
import SummaryCell from "../SummaryCell/SummaryCell";
import styles from "./finalRisk.module.scss";
const STATUS_LABEL = {
    pass: "Pass",
    warning: "Warning",
    fail: "Fail",
};
const FinalRisk = ({ risk, footerWrapper, }) => {
    var _a;
    const finalRisk = getFinalRisk(risk);
    const riskCategory = finalRisk
        ? finalRisk[0]
        : undefined;
    const status = (_a = finalRisk === null || finalRisk === void 0 ? void 0 : finalRisk[1].status) !== null && _a !== void 0 ? _a : "pass";
    return (React.createElement(SummaryCell, { label: `${riskCategory ? ASSESSMENT_TYPE_TO_TITLE[riskCategory] : "Deployment"} Risk`, value: React.createElement("span", { className: `${styles["value-row"]} ${styles[status]}` },
            React.createElement(RiskStatusIcon, { status: status, size: "lg", disabled: false }),
            STATUS_LABEL[status]), subline: finalRisk !== undefined ? (React.createElement(RenderChildrenWrapper, { wrapper: footerWrapper && ((children) => footerWrapper(children)) },
            React.createElement("span", null,
                finalRisk[1].count.toLocaleString(),
                " ",
                finalRisk[1].label))) : (React.createElement("span", null, ALL_RISKS_PASSED_LABEL)) }));
};
export default FinalRisk;
//# sourceMappingURL=FinalRisk.js.map